<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" class="person-icon">
    <g transform="translate(-1520 -284)">
      <path class="person-a" d="M20,21V19a4,4,0,0,0-4-4H8a4,4,0,0,0-4,4v2" transform="translate(1517 282)"/>
      <circle class="person-a" cx="4" cy="4" r="4" transform="translate(1525 285)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PersonIcon'
}
</script>

<style scoped>
svg .person-a {
  fill: none;
  stroke: #FFFFFF;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
